import '../../View';
import { IItem } from './IItem';
export class Key extends IItem {
    constructor(context) {
        super(context);
    }
    /**
     *
     * @return {string}
     */
    getDisplayName() {
        return 'Schl\u00fcssel';
    }
    /**
     *
     */
    onUseFromWorld() {
        this.context
            .getView()
            .console()
            .println$java_lang_String('Ein Schl\u00fcssel. Damit kann man bestimmt etwas \u00f6ffnen.');
    }
    /**
     *
     * @return {string}
     */
    getGender() {
        return 'm';
    }
    /**
     *
     */
    onDrop() { }
    /**
     *
     */
    onTake() { }
    /**
     *
     * @return {boolean}
     */
    onUseFromInventory() {
        return true;
    }
    /**
     *
     */
    onEat() { }
    /**
     *
     * @return {boolean}
     */
    isEdible() {
        return false;
    }
    /**
     *
     * @return {boolean}
     */
    isActivator() {
        return true;
    }
    /**
     *
     * @return {number}
     */
    getValue() {
        return 1;
    }
}
Key['__class'] = 'de.coco.mindLinq.world.items.Key';
